import type { ImageProps } from '@features/powerpoint';

export const CHART_HEIGHT = 501;
export const CHART_WIDTH = 900;

export const CHART_IMAGE_OPTIONS = {
  x: 0.42,
  y: 1.39,
  w: 11.85,
  h: 5.22,
} as const satisfies Pick<ImageProps, 'x' | 'y' | 'w' | 'h'>;
